import { render, staticRenderFns } from "./EventStatusChipRescheduled.vue?vue&type=template&id=79a204ac&scoped=true&"
import script from "./EventStatusChipRescheduled.vue?vue&type=script&lang=js&"
export * from "./EventStatusChipRescheduled.vue?vue&type=script&lang=js&"
import style0 from "./EventStatusChipRescheduled.vue?vue&type=style&index=0&id=79a204ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a204ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
